// noinspection JSUnusedLocalSymbols

import Simplebar from "simplebar";

const singleArticle = () => {

    // Css variables
    const style = document.createElement("style");
    let windowWidth = window.innerWidth - (window.innerWidth - document.documentElement.clientWidth);
    style.innerHTML = `
        :root { 
            --windowWidth: ${windowWidth}px;
        }
    `;
    document.querySelector("body").appendChild(style);
    window.addEventListener("resize", function() {
        windowWidth = window.innerWidth - (window.innerWidth - document.documentElement.clientWidth);
        style.innerHTML = `
            :root { 
                --windowWidth: ${windowWidth}px;
            }
        `;
    });
    // Css variables - END

    // Show more description - START
    const showMoreButton = document.getElementsByClassName('single-article__fulltext-description-more')[0];
    const showMoreButtonText = document.getElementsByClassName('single-article__fulltext-description-more-text')[0];
    const showMoreWrapper     = document.getElementsByClassName('single-article__fulltext-description-wrapper')[0];
    if(showMoreButton) {
        showMoreButton.addEventListener('click', () => {
            if(showMoreWrapper.classList.contains('show')) {
                showMoreWrapper.classList.remove('show');
                showMoreButtonText.innerText = 'czytaj więcej';
                showMoreButton.classList.remove('show-more');
            } else {
                showMoreWrapper.classList.add('show');
                showMoreButtonText.innerText = 'czytaj mniej';
                showMoreButton.classList.add('show-more');
            }
        });
    }
    // Show more description - END

    // Menu detect moment - START
    const links = document.querySelectorAll('.menu-item-js');
    const sections = document.querySelectorAll('[data-section-title]');
    if (links.length > 0) {
        function changeLinkState() {
            let index = sections.length;
            while(--index && window.scrollY + 50 < sections[index].getBoundingClientRect().top + window.scrollY -80) {}
            links.forEach((link) => link.classList.remove('active'));
            links[index].classList.add('active');
        }

        changeLinkState();
        for (let i = 0; i < links.length; i++) {
            links[i].addEventListener('click', function(){
                for (let j = 0; j < sections.length; j++) {
                    if (sections[j].classList.contains(this.dataset.active)) {
                        window.scroll({
                            top : sections[j].getBoundingClientRect().top + window.scrollY - 80,
                            left : 0,
                            behavior : 'smooth'
                        });
                    }
                }
            })
        }
        window.addEventListener('scroll', changeLinkState);
    }
    // Regulations detect slide moment - END

    // Go top button on menu - START
    const goTop = document.getElementsByClassName('single-article__fulltext-menu-top')[0];
    if (goTop) {
        goTop.addEventListener('click', () => {
            window.scroll({
                top : 0,
                left : 0,
                behavior : 'smooth'
            });
        })
    }
    // Go top button on menu - END

    // Open popup drawings - START
    const drawingsBtn = document.getElementsByClassName('single-article__fulltext-order-drawings')[0];
    const drawingsClose = document.getElementsByClassName('single-article__order-popup-wrapper-close')[0];
    const drawingsWrapper = document.getElementsByClassName('single-article__order-popup')[0];
    drawingsBtn && drawingsBtn.addEventListener('click', () => {
        drawingsWrapper.classList.toggle('open');
    });
    drawingsClose && drawingsClose.addEventListener('click', () => {
        drawingsWrapper.classList.toggle('open');
    });
    // Open popup drawings - END

    // Show description on addons - START
    const allAddonsBtns = document.getElementsByClassName('single-article__additions-items-list-item');
    if (allAddonsBtns) {
        for(let i = 0; i < allAddonsBtns.length; i++) {
            allAddonsBtns[i].addEventListener('click', function() {
                this.classList.toggle('show');
            })
        }
    }
    // Show description on addons - END

    // Add simplebar to files in single article - START
    const filesScrollWrapper = document.querySelector('.single-article__fulltext-download-files');
    const filesScrollItems   = document.getElementsByClassName('single-article__fulltext-download-files-item');
    if (filesScrollWrapper) {
        if (filesScrollItems.length > 3) {
            filesScrollWrapper.classList.add('set-height');
            const filesScroll = new Simplebar(filesScrollWrapper, {
                autoHide: false,
            })
        }
    }
    // Add simplebar to files in single article - END

    // Show more on specification - START
    const specificationItems = document.getElementsByClassName('project-specification__item');
    if (specificationItems) {
        for (let i = 0; i < specificationItems.length; i++) {
            specificationItems[i].addEventListener('click', function() {
                this.classList.toggle('show');
            })
        }
    }
    // Show more on specification - END


    // Show more socials - START
    const showMoreSocialsBtn = document.getElementsByClassName('single-article__fulltext-menu-background-socials-btn')[0];
    const socialsItems = document.getElementsByClassName('single-article__fulltext-menu-background-socials')[0];
    if (showMoreSocialsBtn) {
        showMoreSocialsBtn.addEventListener('click', function() {
            socialsItems.classList.toggle('active');
        })
    }
    // Show more socials - END


    // Single mirror reflection - START
    const mirrorReflectionBtn = document.getElementsByClassName('mirror-reflection-js');
    const singleWrapper = document.getElementsByClassName('single-article')[0];
    if (mirrorReflectionBtn) {
        for (let i = 0; i < mirrorReflectionBtn.length; i++) {
            mirrorReflectionBtn[i].addEventListener('click', () => {
                if(singleWrapper) {
                    singleWrapper.classList.toggle('mirror-reflection');
                }
            })
        }
    }
    // Single mirror reflection - END


}

export default singleArticle;
